import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductService } from '@app/api/api';
import { Subscription, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { currentUser, isLoggedIn } from '@app/core/auth';
import { AppState } from '@app/core/reducers';
import { select, Store } from '@ngrx/store';
import { User } from '@app/model/user';
import { CollectionApiResponse, NewArrivalProduct } from '@app/model/new-arrival-product';

@Component({
  selector: 'app-new-arrivals-products',
  templateUrl: './new-arrivals-products.component.html',
  styleUrls: ['./new-arrivals-products.component.scss'],
})
export class NewArrivalsProductsComponent implements OnInit, OnDestroy {
  products: NewArrivalProduct[] = [];
  private subscriptions: Subscription[] = [];
  host = environment.backendhost;

  pageSize: number = 18;
  pageIndex: number = 1;
  totalItems: number = 0;
  showPrice: boolean = false;
  user$: Observable<User>;

  constructor(
    private productService: ProductService,
    public translate: TranslateService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadProducts();
    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.showPrice = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.showPrice = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.showPrice = true;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  loadProducts() {
    this.subscriptions.push(
      this.productService
        .apiProductsNewArrivalsGet(
          'is_hidden==false,is_new_arrival==true',
          '',
          this.pageIndex,
          this.pageSize
        )
        .subscribe((res: CollectionApiResponse<NewArrivalProduct>) => {
          this.products = res && res.data && res.data.collection ? res.data.collection : [];
          this.totalItems = res && res.data && typeof res.data.total === 'number' ? res.data.total : 0;
          this.products.forEach((item: NewArrivalProduct) => {
            item.sale_off = item.origin_price > 0
              ? Math.round(100 - (item.price / item.origin_price) * 100)
              : 0;
            item.seo_name = UtilService.slugify(item.name);
          });
          this.cdr.detectChanges();
        })
    );
  }

  onPageChange(page: number) {
    this.pageIndex = page;
    this.loadProducts();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
